import React, { useMemo } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

const messages = {
    unauthorised: 'Your session has expired',
    notFound: "This page doesn't exist!",
};

export function RouteError() {
    const error = useRouteError();

    const message = useMemo(() => {
        if (isRouteErrorResponse(error)) {
            if (error.status === 404) {
                return messages.notFound;
            }

            if (error.status === 401) {
                return messages.unauthorised;
            }

            if (error.status === 503) {
                return 'Looks like our API is down';
            }

            if (error.status === 418) {
                return '🫖';
            }
        }

        if (error instanceof Error) {
            if (error.message === 'Unauthorized') {
                return messages.unauthorised;
            }
            if (error.message === 'Not Found') {
                return messages.notFound;
            }
        }

        return 'An error occured!';
    }, [error]);

    return (
        <div className="bg-white container mx-auto text-base px-4 pt-5 pb-12 space-y-6">
            <FeaturedIcon size="lg" color="error" className="mb-8" />
            <h1 className="text-2xl text-gray-900 font-medium">{message}</h1>
            {!window.parent &&
                <Button className="inline-block" href={import.meta.env.VITE_MYHEALTH_WEBSITE}>
                    Continue to Myhealth
                </Button>
            }
        </div>
    );
}
